import React, { PropTypes, Component } from 'react';
class chatReview extends Component {
  static propTypes = {
    entities: PropTypes.object.isRequired
  }

  static defaultProps = {
    entities: {}
  }
  reviewerGraph() {
    var list = this.props.entities;
    var users = [0, 0, 0];
    list.map(function(l, index) {
      if (Number(l.user_rank) >= 4.5) {
        users[0] += 1;
      } else if (Number(l.user_rank) < 4.5 && Number(l.user_rank) >= 3) {
        users[1] += 1;
      } else {
        users[2] += 1;
      }
    })
    return users;
  }
  render() {
    if (!Object.keys(this.props.entities).length) {
      return null;
    }
    var entities = this.props.entities;
    var fiveStars = (entities[0].five_stars / entities[0].total_count) * 100;
    fiveStars += "%";
    var fourStars = (entities[0].four_stars / entities[0].total_count) * 100;
    fourStars += "%";
    var threeStars = (entities[0].three_stars / entities[0].total_count) * 100;
    threeStars += "%";
    var twoStars = (entities[0].two_stars / entities[0].total_count) * 100;
    twoStars += "%";
    var oneStars = (entities[0].one_stars / entities[0].total_count) * 100;
    oneStars += "%";

    var typeofusers = this.reviewerGraph();
    var userSuper = (typeofusers[0] / this.props.entities.length) * 100;
    var userModerator = (typeofusers[1] / this.props.entities.length) * 100;
    var userRegular = (typeofusers[2] / this.props.entities.length) * 100;
    return (
      <div>
        <div className="user-details">
          <div style={ { "float": "left", "padding": "2em", "padding-right": "0em" } }>
            <div className="user-rating">Users Rating</div>
            <div style={ { "float": "left" } }>
              <div className="entity-container-reviewsbtn star-btn">5 stars</div>
              <div className="entity-container-reviewsbtn star-btn">4 stars</div>
              <div className="entity-container-reviewsbtn star-btn">3 stars</div>
              <div className="entity-container-reviewsbtn star-btn">2 stars</div>
              <div className="entity-container-reviewsbtn star-btn">1 stars</div>
            </div>
            <div style={ { "float": "left" } }>
              <div className="calculated_star">
                <div style={ { "width": fiveStars } }></div>
              </div>
              <div className="calculated_star">
                <div style={ { "width": fourStars, "background-color": "#BD8D46", "padding": "0.6em 0em" } }></div>
              </div>
              <div className="calculated_star">
                <div style={ { "width": threeStars, "background-color": "#BD8D46", "padding": "0.6em 0em" } }></div>
              </div>
              <div className="calculated_star">
                <div style={ { "width": twoStars, "background-color": "#BD8D46", "padding": "0.6em 0em" } }></div>
              </div>
              <div className="calculated_star">
                <div style={ { "width": oneStars, "background-color": "#BD8D46", "padding": "0.6em 0em" } }></div>
              </div>
            </div>
          </div>
          <div style={ { "float": "left", "padding": "2em", "padding-right": "0em" } }>
            <div className="user-rating">Users Summary</div>
            <div style={ { "float": "left" } }>
              <div className="entity-container-reviewsbtn summary-user-btn">Super users</div>
              <div className="entity-container-reviewsbtn summary-user-btn">Moderators</div>
              <div className="entity-container-reviewsbtn summary-user-btn">Regular</div>
            </div>
            <div style={ { "float": "left" } }>
              <div className="calculated_star">
                <div style={ { "background-color": "#4D1B20", "width": userSuper } } className="superUser"> </div>
              </div>
              <div className="calculated_star">
                <div style={ { "background-color": "#4D1B20", "width": userModerator } } className="moderateUser"> </div>
              </div>
              <div className="calculated_star">
                <div style={ { "background-color": "#4D1B20", "width": userRegular } } className="regularUser"> </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      );
  }
}
module.exports = chatReview;



// WEBPACK FOOTER //
// ./src/components/Chartreview.js